module.exports = __webpack_public_path__ + "static/media/inf_70og71.275dd891.mp3";